import React from 'react';
import { Navigate } from 'react-router-dom';
import { redirectUnlessInventory } from '../../utils/moduleAccess';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import SharedDataTable from '../../_components/Shared/SharedDataTable';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import UploadFiles from '../../_components/upload-files.component';
import UploadFilesService from '../../_services/upload-files.service';
import { handleFocusInScrollField, INVENTORY_MODAL_BODY_SCROLL_STYLE } from './invKeyboardScroll';
import MasterPartNoInput from '../../_components/MasterPartNoInput';
import { isPartNoCreateEnabled, MASTER_PART_NO_VALIDATION_STATUS } from '../../utils/masterPartNoValidation';
import ObsoletePartNoCell from '../../_components/ObsoletePartNoCell';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

let perPage = 30;

class MasterRawMaterial extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            partNo: '',
            partDescription: '',
            packagingType: '',
            packagingTypeOther: '',
            packagingQuantity: 0,
            MOQ: '',
            UoM: '',
            UoMOther: '',
            receivingDock: '',
            receivingDockOther: '',
            incoterms: '',
            incotermsOther: '',
            supplier: '',
            source: '',
            sourceOther: '',
            specialRequirement: '',
            purchasingPrice: 0,
            purchasingPriceCurrency: 'MYR',
            purchasingPriceRate: 1.0,
            editingRate: false,
            shippingMode: '',
            remarks: '',
            photoUrl: '',
            selectedPhoto: null,
            photoPreview: null,
            products: [],
            body: [],
            pageCount: 0,
            keyword: '',
            modalShow: false,
            newMode: false,
            offset: 0,
            locations: [],
            // Default storage location code for this raw material (RM Warehouse)
            defaultLocationCode: '',
            inspection: 'No',
            currencySettings: {
                defaultCurrency: 'MYR',
                currencies: []
            },
            partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE
        };

        this.columns = [
            {
                name: 'Actions',
                cell: (row, rowIndex) => (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '170px', paddingRight: '10px' }}>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => this.onClickProductSelected(null, row, rowIndex)}
                        >
                            Edit
                        </button>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(null, row, rowIndex)}
                        >
                            Delete
                        </button>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '170px',
                minWidth: '170px',
            },
            {
                name: 'Supplier',
                selector: row => row.supplier || '',
                sortable: true,
                maxWidth: '125px',
                width: '125px',
            },
            {
                name: 'Part Number',
                selector: row => row.partNo || '',
                cell: row => <ObsoletePartNoCell value={row.partNo || ''} isObsolete={row.isPartObsolete} />,
                sortable: true,
                maxWidth: '200px',
                width: '200px',
            },
            {
                name: 'Part Description',
                selector: row => row.partDescription || '',
                sortable: true,
                maxWidth: '250px',
                width: '250px',
            },
            {
                name: 'Packaging Type',
                selector: row => {
                    if ((row.packagingType || '') === 'others') {
                        return row.packagingTypeOther || 'others';
                    }
                    return row.packagingType || '';
                },
                sortable: true,
                maxWidth: '180px',
                width: '180px',
            },
            {
                name: 'Packaging Quantity',
                selector: row => row.packagingQuantity || 0,
                sortable: true,
                maxWidth: '170px',
                width: '170px',
            },
            {
                name: 'Default Location',
                selector: row => row.defaultLocationCode || '',
                sortable: true,
                maxWidth: '200px',
                width: '200px',
            },
            {
                name: 'Receiving Dock',
                selector: row => {
                    if ((row.receivingDock || '') === 'others') {
                        return row.receivingDockOther || 'others';
                    }
                    return row.receivingDock || '';
                },
                sortable: true,
                maxWidth: '170px',
                width: '170px',
            }
        ];
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.fetchLocations();
        this.fetchCurrencySettings();
        this.buildHtmlTable();
    }

    fetchCurrencySettings = () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/getCurrencySettings?company=${user.accountId}`, requestOptions)
                .then((response) => {
                    if (response.status === 404) {
                        // Use defaults if settings don't exist
                        return {
                            defaultCurrency: 'MYR',
                            currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                        };
                    }
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.text().then(text => {
                        if (!text || text.trim() === '') {
                            return {
                                defaultCurrency: 'MYR',
                                currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                            };
                        }
                        try {
                            return JSON.parse(text);
                        } catch (e) {
                            console.error('Error parsing JSON:', e);
                            return {
                                defaultCurrency: 'MYR',
                                currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                            };
                        }
                    });
                })
                .then(data => {
                    if (data) {
                        this.setState({
                            currencySettings: data,
                            purchasingPriceCurrency: data.defaultCurrency || 'MYR',
                            purchasingPriceRate: this.getCurrencyRate(data.defaultCurrency || 'MYR', data.currencies || [])
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching currency settings:', error);
                    // Use defaults on error
                    this.setState({
                        currencySettings: {
                            defaultCurrency: 'MYR',
                            currencies: [{ code: 'MYR', name: 'Malaysian Ringgit', rate: 1.0 }]
                        },
                        purchasingPriceCurrency: 'MYR',
                        purchasingPriceRate: 1.0
                    });
                });
        }
    }

    getCurrencyRate = (code, currencies) => {
        const currency = currencies.find(c => c.code === code);
        return currency ? currency.rate : 1.0;
    }

    calculateConvertedPrice = (price, fromCurrency, toCurrency, currencies) => {
        if (!price || price === 0) return 0;
        const fromRate = this.getCurrencyRate(fromCurrency, currencies);
        const toRate = this.getCurrencyRate(toCurrency, currencies);
        if (fromRate === 0) return 0;
        return (price * toRate) / fromRate;
    }

    fetchLocations() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            // Fetch only locations with area = "RM Warehouse"
            fetch(`${config.apiUrl}/getMasterLocations?company=${user.accountId}&area=${encodeURIComponent('RM Warehouse')}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(locations => {
                    if (locations && Array.isArray(locations)) {
                        this.setState((prev) => {
                            const next = { locations };
                            if (locations.length === 1 && locations[0].locationCode && !prev.defaultLocationCode) {
                                next.defaultLocationCode = locations[0].locationCode;
                            }
                            return next;
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching locations:', error);
                    this.setState({ locations: [] });
                });
        }
    }

    exportExcel() {
        utils.tableToExcel('master-raw-material-export-table', 'masterrawmaterial', 'MasterRawMaterial_' + moment().format('YYYYMMDD') + '.xls');
    }

    buildHtmlTable() {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            return fetch(`${config.apiUrl}/getMasterRawMaterial?company=${user.accountId}&keyword=${this.state.keyword}&limit=${perPage}&offset=${this.state.offset}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(body => {
                    let array = [];
                    const products = [];

                    if (body && body.data) {
                        body.data.map((data, index) => {
                            // Check for photoUrl in different possible field names
                            const photoUrl = data.photoUrl || data.photo_url || data.photo || '';
                            
                            array.push({
                                no: index + this.state.offset + 1,
                                id: data.id,
                                partNo: data.partNo || '',
                                partDescription: data.partDescription || '',
                                packagingType: data.packagingType || '',
                                packagingTypeOther: data.packagingTypeOther || '',
                                packagingQuantity: data.packagingQuantity || 0,
                                MOQ: data.MOQ || '',
                                UoM: data.UoM || '',
                                UoMOther: data.UoMOther || '',
                                receivingDock: data.receivingDock || '',
                                receivingDockOther: data.receivingDockOther || '',
                                incoterms: data.incoterms || '',
                                incotermsOther: data.incotermsOther || '',
                                supplier: data.supplier || '',
                                source: data.source || '',
                                sourceOther: data.sourceOther || '',
                                specialRequirement: data.specialRequirement || '',
                                purchasingPrice: data.purchasingPrice || 0,
                                purchasingPriceCurrency: data.purchasingPriceCurrency || 'MYR',
                                purchasingPriceRate: data.purchasingPriceRate || null,
                                shippingMode: data.shippingMode || '',
                                remarks: data.remarks || '',
                                photoUrl: photoUrl,
                                company: data.company || 0,
                                defaultLocationCode: data.defaultLocationCode || '',
                                inspection: (data.inspection && String(data.inspection)) || 'No',
                                isPartObsolete: data.isPartObsolete === true || data.isPartObsolete === 1 || data.isPartObsolete === '1'
                            });
                        });
                    }

                    this.setState({
                        products: array,
                        body: body.data || [],
                        pageCount: body.meta ? Math.ceil(body.meta.total_count / body.meta.limit) : 0,
                        loading: false
                    });
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    this.setState({ products: [], body: [], pageCount: 0, loading: false });
                });
        }
    }

    onClickProductSelected(cell, row, rowIndex) {
        const safeString = (val) => {
            if (val == null || val === undefined) return '';
            const str = String(val);
            return str === 'null' || str === 'undefined' ? '' : str;
        };
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };

        this.setState({
            newMode: false,
            id: safeNumber(row.id),
            partNo: safeString(row.partNo),
            partDescription: safeString(row.partDescription),
            packagingType: safeString(row.packagingType),
            packagingTypeOther: safeString(row.packagingTypeOther),
            packagingQuantity: safeNumber(row.packagingQuantity),
            MOQ: safeString(row.MOQ),
            UoM: safeString(row.UoM),
            UoMOther: safeString(row.UoMOther),
            receivingDock: safeString(row.receivingDock),
            receivingDockOther: safeString(row.receivingDockOther),
            incoterms: safeString(row.incoterms),
            incotermsOther: safeString(row.incotermsOther),
            supplier: safeString(row.supplier),
            source: safeString(row.source),
            sourceOther: safeString(row.sourceOther),
            specialRequirement: safeString(row.specialRequirement),
            purchasingPrice: safeNumber(row.purchasingPrice),
            purchasingPriceCurrency: safeString(row.purchasingPriceCurrency || this.state.currencySettings.defaultCurrency || 'MYR'),
            purchasingPriceRate: safeNumber(row.purchasingPriceRate) || this.getCurrencyRate(safeString(row.purchasingPriceCurrency || this.state.currencySettings.defaultCurrency || 'MYR'), this.state.currencySettings.currencies || []),
            shippingMode: safeString(row.shippingMode),
            remarks: safeString(row.remarks),
            photoUrl: safeString(row.photoUrl),
            defaultLocationCode: safeString(row.defaultLocationCode),
            inspection: safeString(row.inspection) || 'No',
            photoPreview: null,
            selectedPhoto: null
        }, () => {
            setTimeout(() => {
                this.setState({ modalShow: true });
            }, 0);
        });
    }

    onDeleteProduct(cell, row, rowIndex) {
        fetch(`${config.apiUrl}/deleteMasterRawMaterial`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                }
            });
    }

    handlePageClick(data) {
        let selected = data.selected;
        let offset = Math.ceil(selected * perPage);
        this.setState({ offset: offset }, () => {
            this.buildHtmlTable();
        });
    }

    handlePhotoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                selectedPhoto: file,
                photoPreview: URL.createObjectURL(file)
            });
        }
    }

    uploadPhoto = async () => {
        if (!this.state.selectedPhoto) {
            return this.state.photoUrl || '';
        }

        try {
            const response = await UploadFilesService.uploadImage([this.state.selectedPhoto]);
            
            // Handle different possible response structures
            if (response && response.data) {
                // Check if response.data is an array (most common case based on error logs)
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const fileData = response.data[0];
                    // Try different possible URL properties
                    // Priority: url > imgPath > construct from filename > extract from path
                    let photoUrl = '';
                    if (fileData.url) {
                        photoUrl = fileData.url;
                    } else if (fileData.imgPath) {
                        photoUrl = fileData.imgPath;
                    } else if (fileData.filename) {
                        // Construct relative path: img/filename
                        photoUrl = 'img/' + fileData.filename;
                    } else if (fileData.path) {
                        // Extract relative path from absolute path
                        // e.g., /var/www/elexerDashboard/dist/img/file.png -> img/file.png
                        const pathMatch = fileData.path.match(/img\/([^\/]+)$/);
                        if (pathMatch) {
                            photoUrl = 'img/' + pathMatch[1];
                        }
                    }
                    return photoUrl;
                }
                // Check if response.data.files exists
                if (response.data.files && Array.isArray(response.data.files) && response.data.files.length > 0) {
                    const fileData = response.data.files[0];
                    const photoUrl = fileData.url || fileData.imgPath || 
                                   (fileData.filename ? 'img/' + fileData.filename : '');
                    return photoUrl;
                }
                // Check if response.data is directly the URL or file info object
                if (response.data.url) {
                    return response.data.url;
                }
                if (response.data.imgPath) {
                    return response.data.imgPath;
                }
                if (response.data.filename) {
                    return 'img/' + response.data.filename;
                }
                if (typeof response.data === 'string') {
                    return response.data;
                }
            }
            
            console.warn('Unexpected upload response structure:', response);
            return '';
        } catch (error) {
            console.error('Error uploading photo:', error);
            return '';
        }
    }

    openPhotoInNewWindow = (url) => {
        if (!url) return;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    handlePartNoValidationChange = (partNoValidationStatus) => {
        this.setState({ partNoValidationStatus });
    };

    render() {
        const accessDenied = redirectUnlessInventory(localStorage.getItem('user'));
        if (accessDenied) return accessDenied;

        let { keyword, modalShow, newMode, products, locations, body } = this.state;
        
        const safeString = (val) => (val !== undefined && val !== null) ? String(val) : '';
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };

        const partNo = safeString(this.state.partNo);
        const partDescription = safeString(this.state.partDescription);
        const packagingType = safeString(this.state.packagingType);
        const packagingTypeOther = safeString(this.state.packagingTypeOther);
        const packagingQuantity = safeNumber(this.state.packagingQuantity);
        const MOQ = safeString(this.state.MOQ);
        const UoM = safeString(this.state.UoM);
        const UoMOther = safeString(this.state.UoMOther);
        const receivingDock = safeString(this.state.receivingDock);
        const receivingDockOther = safeString(this.state.receivingDockOther);
        const incoterms = safeString(this.state.incoterms);
        const incotermsOther = safeString(this.state.incotermsOther);
        const supplier = safeString(this.state.supplier);
        const source = safeString(this.state.source);
        const sourceOther = safeString(this.state.sourceOther);
        const specialRequirement = safeString(this.state.specialRequirement);
        const purchasingPrice = safeNumber(this.state.purchasingPrice);
        const totalPurchasingPrice = purchasingPrice * packagingQuantity;
        const shippingMode = safeString(this.state.shippingMode);
        const remarks = safeString(this.state.remarks);
        const defaultLocationCode = safeString(this.state.defaultLocationCode);

        let handleClose = () => {
            this.setState({
                modalShow: false,
                id: 0,
                partNo: '',
                partDescription: '',
                packagingType: '',
                packagingTypeOther: '',
                packagingQuantity: 0,
                MOQ: '',
                UoM: '',
                UoMOther: '',
                receivingDock: '',
                receivingDockOther: '',
                incoterms: '',
                incotermsOther: '',
                supplier: '',
                source: '',
                sourceOther: '',
                specialRequirement: '',
                purchasingPrice: 0,
                purchasingPriceCurrency: this.state.currencySettings.defaultCurrency || 'MYR',
                purchasingPriceRate: this.getCurrencyRate(this.state.currencySettings.defaultCurrency || 'MYR', this.state.currencySettings.currencies || []),
                editingRate: false,
                shippingMode: '',
                remarks: '',
                photoUrl: '',
                selectedPhoto: null,
                photoPreview: null,
                defaultLocationCode: '',
                inspection: 'No',
                partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE
            });
        };

        const fetchInspectionForPartNo = () => {
            const pn = (this.state.partNo || '').trim();
            if (!pn) {
                this.setState({ inspection: 'No' });
                return;
            }
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.accountId) return;
                fetch(`${config.apiUrl}/getInspectionStatusForPartNo?company=${user.accountId}&partNo=${encodeURIComponent(pn)}`, { method: 'GET', headers: { 'Accept': 'application/json' } })
                    .then(res => res.json())
                    .then(data => {
                        this.setState({ inspection: (data && data.inspection === 'Yes') ? 'Yes' : 'No' });
                    })
                    .catch(() => this.setState({ inspection: 'No' }));
            } catch (e) {
                this.setState({ inspection: 'No' });
            }
        };

        let handleSave = async () => {
            if (!window.confirm("Are you sure you want to update this data?")) return;

            let photoUrl = this.state.photoUrl;
            if (this.state.selectedPhoto) {
                photoUrl = await this.uploadPhoto();
            }

            fetch(`${config.apiUrl}/updateMasterRawMaterial`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: this.state.id,
                    partNo,
                    partDescription,
                    packagingType,
                    packagingTypeOther,
                    packagingQuantity,
                    MOQ,
                    UoM,
                    UoMOther,
                    receivingDock,
                    receivingDockOther,
                    incoterms,
                    incotermsOther,
                    supplier,
                    source,
                    sourceOther,
                    specialRequirement,
                    purchasingPrice,
                    purchasingPriceCurrency: this.state.purchasingPriceCurrency,
                    purchasingPriceRate: this.state.purchasingPriceRate,
                    shippingMode,
                    remarks,
                                                    photoUrl,
                                                    defaultLocationCode: this.state.defaultLocationCode,
                                                    inspection: this.state.inspection || 'No'
                })
            })
                .then(async (response) => {
                    if (response.status == 200) {
                        await response.json().catch(() => null);
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    } else {
                        const errorText = await response.text().catch(() => 'Unknown error');
                        console.error('Update failed:', response.status, errorText);
                    }
                })
                .catch(error => {
                    console.error('Error updating:', error);
                });
        }

        let handleCreate = async () => {
            let photoUrl = '';
            if (this.state.selectedPhoto) {
                photoUrl = await this.uploadPhoto();
            }

            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/createMasterRawMaterial`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    partNo,
                    partDescription,
                    packagingType,
                    packagingTypeOther,
                    packagingQuantity,
                    MOQ,
                    UoM,
                    UoMOther,
                    receivingDock,
                    receivingDockOther,
                    incoterms,
                    incotermsOther,
                    supplier,
                    source,
                    sourceOther,
                    specialRequirement,
                    purchasingPrice,
                    purchasingPriceCurrency: this.state.purchasingPriceCurrency,
                    purchasingPriceRate: this.state.purchasingPriceRate,
                    shippingMode,
                    remarks,
                    photoUrl,
                    defaultLocationCode: this.state.defaultLocationCode,
                    inspection: this.state.inspection || 'No',
                    company: user.accountId
                })
            })
                .then(async (response) => {
                    if (response.status == 200) {
                        await response.json().catch(() => null);
                        this.setState({ modalShow: false, newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    } else {
                        const errorText = await response.text().catch(() => 'Unknown error');
                        console.error('Create failed:', response.status, errorText);
                    }
                })
                .catch(error => {
                    console.error('Error creating:', error);
                });
        }

        return (
            <div className="container">
                <div style={{
                    marginBottom: '20px',
                    position: 'relative',
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineName">
                            <FormControl
                                type="text"
                                placeholder="Search..."
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }}
                                value={keyword || ''}
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.buildHtmlTable()}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        <Button
                            bsStyle="danger"
                            onClick={e => {
                                this.setState({
                                    id: 0,
                                    partNo: '',
                                    partDescription: '',
                                    packagingType: '',
                                    packagingTypeOther: '',
                                    packagingQuantity: 0,
                                    MOQ: '',
                                    UoM: '',
                                    UoMOther: '',
                                    receivingDock: '',
                                    receivingDockOther: '',
                                    incoterms: '',
                                    incotermsOther: '',
                                    supplier: '',
                                    source: '',
                                    sourceOther: '',
                                    specialRequirement: '',
                                    purchasingPrice: 0,
                                    purchasingPriceCurrency: this.state.currencySettings.defaultCurrency || 'USD',
                                    purchasingPriceRate: this.getCurrencyRate(this.state.currencySettings.defaultCurrency || 'USD', this.state.currencySettings.currencies || []),
                                    editingRate: false,
                shippingMode: '',
                remarks: '',
                photoUrl: '',
                selectedPhoto: null,
                photoPreview: null,
                defaultLocationCode: '',
                inspection: 'No',
                partNoValidationStatus: MASTER_PART_NO_VALIDATION_STATUS.IDLE,
                newMode: true,
                modalShow: true
                                });
                            }}>New</Button>
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" className="container">
                    <SharedDataTable
                        columns={this.columns}
                        data={products || []}
                        progressPending={this.state.loading}
                        progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading raw materials" />}
                        pagination
                    />
                </div>
                {/* Hidden export table for Excel */}
                <div id="master-raw-material-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Supplier</th>
                                <th style={{ padding: '6px' }}>Part Number</th>
                                <th style={{ padding: '6px' }}>Part Description</th>
                                <th style={{ padding: '6px' }}>Packaging Type</th>
                                <th style={{ padding: '6px' }}>Packaging Type Other</th>
                                <th style={{ padding: '6px' }}>Packaging Quantity</th>
                                <th style={{ padding: '6px' }}>MOQ</th>
                                <th style={{ padding: '6px' }}>UoM</th>
                                <th style={{ padding: '6px' }}>UoM Other</th>
                                <th style={{ padding: '6px' }}>Default Location</th>
                                <th style={{ padding: '6px' }}>Receiving Dock</th>
                                <th style={{ padding: '6px' }}>Receiving Dock Other</th>
                                <th style={{ padding: '6px' }}>Incoterms</th>
                                <th style={{ padding: '6px' }}>Incoterms Other</th>
                                <th style={{ padding: '6px' }}>Source</th>
                                <th style={{ padding: '6px' }}>Source Other</th>
                                <th style={{ padding: '6px' }}>Special Requirement</th>
                                <th style={{ padding: '6px' }}>Purchasing Price (/pc)</th>
                                <th style={{ padding: '6px' }}>Purchasing Price Currency</th>
                                <th style={{ padding: '6px' }}>Purchasing Price Rate</th>
                                <th style={{ padding: '6px' }}>Shipping Mode</th>
                                <th style={{ padding: '6px' }}>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(body || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{index + 1}</td>
                                    <td style={{ padding: '4px' }}>{item.supplier || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partNo || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.partDescription || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingType || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingTypeOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.packagingQuantity || 0}</td>
                                    <td style={{ padding: '4px' }}>{item.MOQ || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.UoM || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.UoMOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.defaultLocationCode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.receivingDock || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.receivingDockOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.incoterms || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.incotermsOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.source || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.sourceOther || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.specialRequirement || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.purchasingPrice || 0}</td>
                                    <td style={{ padding: '4px' }}>{item.purchasingPriceCurrency || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.purchasingPriceRate || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.shippingMode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.remarks || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            {newMode ? (<Modal.Title>New Raw Material</Modal.Title>) : (<Modal.Title>Edit Raw Material</Modal.Title>)}
                        </Modal.Header>
                        <Modal.Body style={INVENTORY_MODAL_BODY_SCROLL_STYLE} onFocusCapture={handleFocusInScrollField}>
                            <div>
                                <Form>
                                    <Row>
                                        <Col sm={6}>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part No</Form.Label></Col>
                                                <Col sm={9}>
                                                    <MasterPartNoInput
                                                        value={partNo}
                                                        onChange={value => this.setState({ partNo: value })}
                                                        enabled={true}
                                                        onValidationChange={this.handlePartNoValidationChange}
                                                        formControlProps={{ onBlur: fetchInspectionForPartNo }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Inspection</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" disabled value={this.state.inspection || 'No'} style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Part Description</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ partDescription: ev.target.value }) }} value={partDescription} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Packaging Type</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={packagingType} onChange={(e) => {
                                                    this.setState({ packagingType: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="carton">Carton</option>
                                                    <option value="pallet">Pallet</option>
                                                    <option value="box">Box</option>
                                                    <option value="others">Others</option>
                                                </FormControl>
                                                {packagingType === 'others' && (
                                                    <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ packagingTypeOther: ev.target.value }) }} value={packagingTypeOther} />
                                                )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Packaging Quantity</Form.Label></Col>
                                                <Col sm={9}><FormControl type="number" min="0" onChange={ev => { this.setState({ packagingQuantity: Number(ev.target.value) || 0 }) }} value={packagingQuantity} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>MOQ</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ MOQ: ev.target.value }) }} value={MOQ} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>UoM</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={UoM} onChange={(e) => {
                                                    this.setState({ UoM: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="pcs">PCS</option>
                                                    <option value="kg">KG</option>
                                                    <option value="liter">Liter</option>
                                                    <option value="gram">Gram</option>
                                                    <option value="others">Others</option>
                                                </FormControl>
                                                {UoM === 'others' && (
                                                    <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ UoMOther: ev.target.value }) }} value={UoMOther} />
                                                )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Receiving Dock</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={receivingDock} onChange={(e) => {
                                                    this.setState({ receivingDock: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="not applicable">Not Applicable</option>
                                                    <option value="others">Others</option>
                                                </FormControl>
                                                {receivingDock === 'others' && (
                                                    <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ receivingDockOther: ev.target.value }) }} value={receivingDockOther} />
                                                )}
                                                </Col>
                                            </FormGroup>
                                        <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                            <Col sm={3}><Form.Label>Default Location</Form.Label></Col>
                                            <Col sm={9}>
                                                <FormControl
                                                    as="select"
                                                    value={defaultLocationCode}
                                                    onChange={e => this.setState({ defaultLocationCode: e.target.value })}
                                                >
                                                    <option value="">-- Select Location --</option>
                                                    {(locations || []).map(loc => (
                                                        <option key={loc.id} value={loc.locationCode}>
                                                            {loc.locationCode} - {loc.locationDescription}
                                                        </option>
                                                    ))}
                                                </FormControl>
                                            </Col>
                                        </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Incoterms</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={incoterms} onChange={(e) => {
                                                    this.setState({ incoterms: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="CIP">CIP - Carriage and Insurance Paid to</option>
                                                    <option value="CPT">CPT - Carriage Paid to</option>
                                                    <option value="CFR">CFR - Cost and Freight</option>
                                                    <option value="CIF">CIF - Cost, Insurance, and Freight</option>
                                                    <option value="DAP">DAP - Delivered at Place</option>
                                                    <option value="DPU">DPU - Delivered at Place Unloaded</option>
                                                    <option value="DDP">DDP - Delivered Duty Paid</option>
                                                    <option value="EXW">EXW - Ex Works</option>
                                                    <option value="FAS">FAS - Free Alongside Ship</option>
                                                    <option value="FCA">FCA - Free Carrier</option>
                                                    <option value="FOB">FOB - Free on Board</option>
                                                    <option value="others">Others</option>
                                                </FormControl>
                                                {incoterms === 'others' && (
                                                    <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ incotermsOther: ev.target.value }) }} value={incotermsOther} />
                                                )}
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                        <Col sm={6}>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Supplier</Form.Label></Col>
                                                <Col sm={9}><FormControl type="text" onChange={ev => { this.setState({ supplier: ev.target.value }) }} value={supplier} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Source</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={source} onChange={(e) => {
                                                    this.setState({ source: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="Buy">Buy</option>
                                                    <option value="Make">Make</option>
                                                    <option value="Consignment">Consignment</option>
                                                    <option value="others">Others</option>
                                                </FormControl>
                                                {source === 'others' && (
                                                    <FormControl type="text" placeholder="Please specify" style={{ marginTop: '5px' }} onChange={ev => { this.setState({ sourceOther: ev.target.value }) }} value={sourceOther} />
                                                )}
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Special Requirement</Form.Label></Col>
                                                <Col sm={9}><FormControl as="textarea" rows={3} onChange={ev => { this.setState({ specialRequirement: ev.target.value }) }} value={specialRequirement} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Purchasing Price (/pc)</Form.Label></Col>
                                                <Col sm={9}>
                                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                        <div style={{ flex: '1', minWidth: '150px' }}>
                                                            <FormControl 
                                                                type="number" 
                                                                step="0.01" 
                                                                min="0" 
                                                                onChange={ev => { this.setState({ purchasingPrice: Number(ev.target.value) || 0 }) }} 
                                                                value={purchasingPrice} 
                                                            />
                                                        </div>
                                                        <div style={{ minWidth: '100px' }}>
                                                            <FormControl
                                                                as="select"
                                                                value={this.state.purchasingPriceCurrency}
                                                                onChange={(e) => {
                                                                    const selectedCurrency = e.target.value;
                                                                    // When switching currency, always update to the default rate from currency settings
                                                                    const defaultRate = this.getCurrencyRate(selectedCurrency, this.state.currencySettings.currencies || []);
                                                                    this.setState({ 
                                                                        purchasingPriceCurrency: selectedCurrency,
                                                                        purchasingPriceRate: defaultRate,
                                                                        editingRate: false
                                                                    });
                                                                }}
                                                            >
                                                                {this.state.currencySettings.currencies.map(currency => (
                                                                    <option key={currency.code} value={currency.code}>
                                                                        {currency.code}
                                                                    </option>
                                                                ))}
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                                        <div style={{ marginBottom: '5px' }}>
                                                            <strong>Total Price ({packagingQuantity || 0} pcs):</strong>{' '}
                                                            {totalPurchasingPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {this.state.purchasingPriceCurrency || 'MYR'}
                                                        </div>
                                                        <div style={{ marginBottom: '5px' }}>
                                                            <strong>Exchange Rate:</strong>{' '}
                                                            {this.state.editingRate ? (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                                                    <FormControl
                                                                        type="number"
                                                                        step="0.0001"
                                                                        min="0"
                                                                        value={this.state.purchasingPriceRate}
                                                                        onChange={(e) => this.setState({ purchasingPriceRate: parseFloat(e.target.value) || 0 })}
                                                                        style={{ width: '100px', display: 'inline-block' }}
                                                                        autoFocus
                                                                    />
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        onClick={() => this.setState({ editingRate: false })}
                                                                    >
                                                                        Save
                                                                    </Button>
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {this.state.purchasingPriceRate.toFixed(4)}
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        onClick={() => this.setState({ editingRate: true })}
                                                                        style={{ padding: '0 5px', fontSize: '12px' }}
                                                                    >
                                                                        (Edit)
                                                                    </Button>
                                                                </span>
                                                            )}
                                                        </div>
                                                        {this.state.currencySettings.defaultCurrency && 
                                                         this.state.purchasingPriceCurrency !== this.state.currencySettings.defaultCurrency && (
                                                            <>
                                                            <div style={{ marginBottom: '5px' }}>
                                                                <strong>Converted to {this.state.currencySettings.defaultCurrency}:</strong>{' '}
                                                                {(() => {
                                                                    const fromRate = this.state.purchasingPriceRate || this.getCurrencyRate(this.state.purchasingPriceCurrency, this.state.currencySettings.currencies || []);
                                                                    const toRate = this.getCurrencyRate(this.state.currencySettings.defaultCurrency, this.state.currencySettings.currencies || []);
                                                                    if (fromRate === 0 || !purchasingPrice) return '0.00';
                                                                    return ((purchasingPrice * toRate) / fromRate).toFixed(2);
                                                                })()}
                                                            </div>
                                                            <div>
                                                                <strong>Total converted ({packagingQuantity || 0} pcs):</strong>{' '}
                                                                {(() => {
                                                                    const fromRate = this.state.purchasingPriceRate || this.getCurrencyRate(this.state.purchasingPriceCurrency, this.state.currencySettings.currencies || []);
                                                                    const toRate = this.getCurrencyRate(this.state.currencySettings.defaultCurrency, this.state.currencySettings.currencies || []);
                                                                    if (fromRate === 0) return '0.00';
                                                                    const convertedTotal = (totalPurchasingPrice * toRate) / fromRate;
                                                                    return convertedTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                                                                })()} {this.state.currencySettings.defaultCurrency}
                                                            </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Shipping Mode</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl as="select" value={shippingMode} onChange={(e) => {
                                                    this.setState({ shippingMode: e.target.value });
                                                }}>
                                                    <option value="">Select</option>
                                                    <option value="Sea">Sea</option>
                                                    <option value="Air">Air</option>
                                                    <option value="Land">Land</option>
                                                </FormControl>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Remarks</Form.Label></Col>
                                                <Col sm={9}><FormControl as="textarea" rows={3} onChange={ev => { this.setState({ remarks: ev.target.value }) }} value={remarks} /></Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Upload Photo</Form.Label></Col>
                                                <Col sm={9}>
                                                <FormControl type="file" accept="image/*" onChange={this.handlePhotoChange} />
                                                <small className="text-muted" style={{ fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                                    Supported formats: JPG, PNG, GIF. Maximum file size: 5MB
                                                </small>
                                                {this.state.photoPreview && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        <img src={this.state.photoPreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                                        <div style={{ marginTop: '8px' }}>
                                                            <Button
                                                                type="button"
                                                                bsStyle="info"
                                                                onClick={() => this.openPhotoInNewWindow(this.state.photoPreview)}
                                                            >
                                                                Open
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                                {!this.state.photoPreview && this.state.photoUrl && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        <img src={this.state.photoUrl} alt="Current" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                                                        <div style={{ marginTop: '8px' }}>
                                                            <Button
                                                                type="button"
                                                                bsStyle="info"
                                                                onClick={() => this.openPhotoInNewWindow(this.state.photoUrl)}
                                                            >
                                                                Open
                                                            </Button>
                                                        </div>
                                                    </div>
                                                )}
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {newMode && (<Button variant="primary" onClick={handleCreate} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Create
                            </Button>)}
                            {!newMode && (<Button variant="primary" onClick={handleSave} disabled={!isPartNoCreateEnabled(this.state.partNoValidationStatus)}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

export { MasterRawMaterial };
